import packageJson from '../../../package.json';
import { isWebviewAndroid, isWebviewIOS } from './controlDevices';

const getVersionWebview = () => {
    if (isWebviewAndroid) return `webviews-android-${packageJson.version}`;
    if (isWebviewIOS) return `webviews-ios-${packageJson.version}`;
    return `webviews-web-${packageJson.version}`;
};

export default getVersionWebview;
